import { render, staticRenderFns } from "./ModalCatecumeno.vue?vue&type=template&id=291cc98d&"
import script from "./ModalCatecumeno.vue?vue&type=script&lang=js&"
export * from "./ModalCatecumeno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports